import { List } from 'immutable';
import { dividendConstants } from '../constants';

export function dividends(state = {}, action) {
  switch (action.type) {
    case dividendConstants.DIVIDEND_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case dividendConstants.DIVIDEND_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case dividendConstants.DIVIDEND_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };

    case dividendConstants.DIVIDEND_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case dividendConstants.DIVIDEND_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case dividendConstants.DIVIDEND_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case dividendConstants.DIVIDEND_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case dividendConstants.DIVIDEND_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const dividendIndex = state.items.findIndex(val => val.id == action.response.id);

      if (dividendIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(dividendIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case dividendConstants.DIVIDEND_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case dividendConstants.DIVIDEND_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case dividendConstants.DIVIDEND_DELETE_SUCCESS: {
      const { dividendId } = action;

      if (!state.items) {
        return state;
      }

      const dividendIndex = state.items.findIndex(val => val.id == dividendId);

      if (dividendIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(dividendIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case dividendConstants.DIVIDEND_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };

    case dividendConstants.DIVIDEND_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    case dividendConstants.DIVIDEND_SYNC_LOADING:
      return {
        ...state,
        syncLoading: true,
        syncError: null
      };
    case dividendConstants.DIVIDEND_SYNC_SUCCESS:
      return {
        ...state,
        syncLoading: false,
        syncError: null
      };
    case dividendConstants.DIVIDEND_SYNC_FAILURE:
      return {
        ...state,
        syncLoading: false,
        syncError: action.error
      };
    default:
      return state;
  }
}
